import script from "./carousel-picture.vue?vue&type=script&setup=true&lang=ts"
export * from "./carousel-picture.vue?vue&type=script&setup=true&lang=ts"

import "./carousel-picture.vue?vue&type=style&index=0&id=20d9bf0d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d9bf0d"]])

export default __exports__